import {Divider} from "antd";
import {SingleLayerTime} from "../singleLayer/SingleLayerTime";

export function SplitViewLayerTime({
                                       id,
                                       isTime,
                                       dataTime,
                                       timeSelectedIdx,
                                       setTimeSelectedIdx,
                                       idTwo,
                                       isTimeTwo,
                                       dataTimeTwo,
                                       timeTwoSelectedIdx,
                                       setTimeTwoSelectedIdx
                                   }) {
    return (
        <>
            {isTime && <SingleLayerTime
                id={id}
                dataTime={dataTime}
                timeSelectedIdx={timeSelectedIdx}
                setTimeSelectedIdx={setTimeSelectedIdx}
            ></SingleLayerTime>}
            {isTimeTwo && <SingleLayerTime
                id={idTwo}
                dataTime={dataTimeTwo}
                timeSelectedIdx={timeTwoSelectedIdx}
                setTimeSelectedIdx={setTimeTwoSelectedIdx}
            ></SingleLayerTime>}
        </>
    )
}